import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { markNativeShell, initNativeOAuthListener } from './lib/nativeAuth'
import './styles.css'
import './styles.mobile.css'

markNativeShell()
initNativeOAuthListener()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
